import styled, { keyframes } from "styled-components";
import StarImage from '../../../../asset/mama/star.png';
import { TextElem } from "../../../../common/text";

type ColorType = 'yellow' | 'pink';

type Props = {
  color: ColorType;
  direction?: 'left' | 'right';
  rotate?: number;
};

const MARQUEE_THEME = {
  yellow: {
    bg: `
      linear-gradient(
        90deg,
        #fffcf5 0%,
        #ffcd00 48.89%,
        #fffcf5 100%
      )
    `,
    color: "black",
    shadow: 'rgba(0, 0, 0, 0.15)',
  },
  pink: {
    bg: `
      linear-gradient(
        90deg,
        #fff5fa 0%,
        #ff0480 48.89%,
        #fff5fa 100%
      )
    `,
    color: "white",
    shadow: 'rgba(0, 0, 0, 0.15)',
  },
} as const;

export const Component: React.FC<Props> = ({
  color = 'yellow',
  direction = 'left',
  rotate = 0,
}) => {
  return (
    <MarqueeWrapper $rotate={rotate} $color={color}>
      <MarqueeTrack $rotate={direction}>
        {[...Array(8)].map((_, index) => (
          <MarqueeContent key={index}>
            <Icon src={StarImage} alt="" />
            <TextElem color={MARQUEE_THEME[color].color} fontFamily="Dela Gothic One" tid="MAMA.MARQUEE.ONE" />

            <Icon src={StarImage} alt="" />
            <TextElem color={MARQUEE_THEME[color].color} fontFamily="Dela Gothic One" tid="MAMA.MARQUEE.TWO" />

            <Icon src={StarImage} alt="" />
            <TextElem color={MARQUEE_THEME[color].color} fontFamily="Dela Gothic One" tid="MAMA.MARQUEE.THREE" />
          </MarqueeContent>
        ))}
      </MarqueeTrack>
    </MarqueeWrapper>
  );
};

const marqueeAnimation = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
`;

const getAnimation = (rotate: 'left' | 'right') => {
  return rotate === 'left'
    ? marqueeAnimation
    : keyframes`
        from {
          transform: translateX(-50%);
        }
        to {
          transform: translateX(0);
        }
      `;
};

export const MarqueeWrapper = styled.div<{ $color: ColorType, $rotate: number }>`
  position: relative;
  width: 100%;
  height: 48px;
  overflow: hidden;
  rotate: ${props => props.$rotate}deg;
  z-index: 1;

  background: ${({ $color }) => MARQUEE_THEME[$color].bg};
  box-shadow: 0px 10px 0px ${({ $color }) => MARQUEE_THEME[$color].shadow};

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -14px;
    width: 100%;
    height: 14px;

    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.18),
      rgba(0, 0, 0, 0)
    );

    pointer-events: none;
  }
`;

export const MarqueeTrack = styled.div<{ $rotate: 'left' | 'right' }>`
  display: flex;
  width: max-content;
  animation: ${({ $rotate }) => getAnimation($rotate)} 40s linear infinite;
`;

export const MarqueeContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 10px;
  flex-shrink: 0;
`;

export const Icon = styled.img`
  width: 38px;
  height: 40px;
  object-fit: contain;
`;